import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type ResourceTranslations = {
  [lang: string]: Translation;
};

export const resourceTranslations: ResourceTranslations = {
  en,
};
